import { DatePipe, registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import { DEFAULT_CURRENCY_CODE, ErrorHandler, Injector, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '@app/app-routing.module';
import { AppComponent } from '@app/app.component';
import { environment } from '@env/environment';
import { Ng9RutModule } from 'ng9-rut';
import { NgxImageCompressService } from 'ngx-image-compress';
import '../polyfills';
import { AuthGuard } from '@app/guards/auth.guard';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { GlobalErrorChunkHandler } from './helpers/global-error-chunk-load';
import { PipesModule } from './pipes/pipes.module';
import { InjectorModalService } from './services/injectorModal.service';
import { FormsModule } from '@angular/forms';

registerLocaleData(localeEs);

export let AppInjector: Injector;

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'app-profe-jobs' }),
    AppRoutingModule,
    Ng9RutModule,
    PipesModule,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage())
  ],
  providers: [
    AuthGuard,
    InjectorModalService,
    NgxImageCompressService,
    DatePipe,
    { provide: ErrorHandler, useClass: GlobalErrorChunkHandler },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'CLP' },
    { provide: LOCALE_ID, useValue: 'es-ES' },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private injector: Injector) {
    AppInjector = this.injector;
  }
}
